


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import ChartRunningPhaseAngles from '@/components/charts/running/ChartRunningPhaseAngles.vue';
import ChartRunningPronationSupinationAngles from '@/components/charts/running/CharRunningPronationSupinationAngles.vue';

@Component({
  components: { ChartRunningPhaseAngles, ChartRunningPronationSupinationAngles },
})
export default class PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAngles extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
  @Prop({ required: true, default: false }) private modeIsAdvanced!: boolean;

  get isNewAnalysis() {
    return this.$pdc.helper?.isNewAnalysis(this.acquisition.computed_data);
  }
}
